<template>
  <div :class="containerClasses">
    <component
      :is="iconComponent"
      class="shrink-0"
    />
    <div :class="contentClasses">
      <!--      <div>Tento účet je propojen s</div>-->
      <!--      <b class="mt-[-4px]">{{ props.provider }} účtem.</b>-->
      <div>
        {{ $t('error_account_exist') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BadgeIcon from '@/assets/icons/BadgeIcon.vue'
import { isPets } from '@/comp/AppType'
import PetsPromotionIcon from '../../../../findee/src/assets/images/apps/pets/PromotionIcon.vue'

defineProps({
  provider: {
    required: true,
    type: String
  }
})

const iconComponent = computed(() => (isPets.value ? PetsPromotionIcon : BadgeIcon))
const containerClasses = computed(() =>
  isPets.value
    ? 'w-full rounded-lg flex items-start p-4 bg-tertiary-3'
    : 'bg-backgrounds-p4 rounded-sm px-4 py-3 flex items-center space-x-5'
)
const contentClasses = computed(() =>
  isPets.value ? 'w-full pl-4 text-lg leading-tight text-grey-0' : 'text-primary-0 leading-tight'
)
</script>
